import { render, staticRenderFns } from "./GoodHot.vue?vue&type=template&id=5978a60a&scoped=true"
import script from "./GoodHot.vue?vue&type=script&lang=js"
export * from "./GoodHot.vue?vue&type=script&lang=js"
import style0 from "./GoodHot.vue?vue&type=style&index=0&id=5978a60a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978a60a",
  null
  
)

export default component.exports